import {lazy} from 'react';
import {ROUTES} from '@/routePaths';

// The future src/routes.js. Plain paths — the /v3 prefix that hosts these today lives only in
// src/v3Bridge.jsx, so this file needs no edit at cutover. The map shape is interim as well: it
// mirrors v1's so the bridge can merge the two, and gives way to React Router's own route objects
// (createBrowserRouter, nested routes, loaders) once nothing reads this table by path.
export const routes = {
	[ROUTES.INTEGRATIONS]: {
		ff: 'ff_v3_integrations',
		Comp: lazy(() => import('@v3/pages/Integrations')),
	},
};
